import {
  CONVERSATION_PERMISSIONS,
  ROLES,
} from 'dashboard/constants/permissions';
import { frontendURL } from '../../../helper/URLHelper';
import TicketsIndex from './pages/TicketsIndex.vue';

// «Тикеты» tab (TOPS-213): tickets first, the chat only on request.
export const routes = [
  {
    path: frontendURL('accounts/:accountId/tickets/:ticketId?'),
    name: 'operator_tickets_index',
    component: TicketsIndex,
    meta: { permissions: [...ROLES, ...CONVERSATION_PERMISSIONS] },
  },
];
